<template>
  <header 
    id="header"
    class="header" 
    :class="{ 
      'dark': $root.theme == 'dark', 
      'hide': $root.menuOpen 
    }">
    <div class="header-outline">
      <nav class="nav">
        <router-link :to="{ name: 'Home' }" class="logo">Han</router-link>
        <router-link :to="{ name: 'Project' }" class="menu">Projects</router-link>
        <router-link :to="{ name: 'About' }" class="menu">About</router-link>
      </nav>

      <Menu />
    </div>
  </header>



  <div class="nav-menu" :class="{ 'open' : $root.menuOpen }">
    <div class="menu-wrap">
      <div class="menu-row">
        <router-link :to="{ name: 'Home' }" class="menu">Home</router-link>
      </div>
      <div class="menu-row">
        <router-link :to="{ name: 'Project' }" class="menu">Projects</router-link>
      </div>
      <div class="menu-row">
        <router-link :to="{ name: 'About' }" class="menu">About</router-link>
      </div>
      <div class="menu-row">
        <a href="https://medium.com/@hanbyeolljang" target="_blank" class="menu">Blog</a>
        <a href="https://medium.com/@hanbyeolljang" target="_blank" class="menu-sub">Medium</a>
      </div>
      <div class="menu-row social-menu">
        Follow me :)
        
        <a href="https://www.linkedin.com/in/hanbyeoll/" target="_blank"><img src="/portfolio/images/icon-linkdin.png" /></a>
        <a href="https://dribbble.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-dribbble.png" /></a>
        <a href="https://www.behance.net/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-behance.png" /></a>
        <a href="https://github.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-github.png" /></a>
      </div>
    </div>

    <div class="bg"></div>
  </div>
</template>

<script>
import Menu from './Menu.vue'


export default {
  name: 'Header',
  components: {
    Menu,
  },
  data() {
    return {
      lastScrollTop : 0,
    }
  },
  mounted() {
    document.addEventListener('scroll', () => {
      if(document.documentElement.scrollTop > 200) {
        var st = window.pageYOffset || document.documentElement.scrollTop
        if (st > this.lastScrollTop){
          document.getElementById('header').classList.remove('up')
          document.getElementById('header').classList.add('down')
        } else {
          document.getElementById('header').classList.add('up')
          document.getElementById('header').classList.remove('down')
        }
        this.lastScrollTop = st <= 0 ? 0 : st
      }else{
        document.getElementById('header').classList.remove('up')
        document.getElementById('header').classList.remove('down')
      }

    }, false)
  },
}
</script>


